import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';
import { formatDateOnly } from '../utils/dateOnly';
import './Changelog.css';

const Changelog = () => {
  const navigate = useNavigate();
  const { hasPermission, user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchChangelog = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const response = await fetch(getApiUrl('changelog'), {
          headers: {
            'Authorization': token ? `Bearer ${token}` : ''
          }
        });
        if (response.ok) {
          const data = await response.json();
          const list = Array.isArray(data)
            ? data
            : (Array.isArray(data.data) ? data.data : []);
          setItems(list);
        } else if (response.status === 401) {
          // Sem autenticação: usar endpoint público
          const pub = await fetch(getApiUrl('changelog/public'));
          if (pub.ok) {
            const data = await pub.json();
            const list = Array.isArray(data)
              ? data
              : (Array.isArray(data.data) ? data.data : []);
            setItems(list);
          } else {
            setError('Não foi possível carregar o changelog público');
          }
        } else {
          setError('Não foi possível carregar o changelog');
        }
      } catch (err) {
        console.error('Erro ao carregar changelog:', err);
        setError('Erro ao carregar changelog');
      } finally {
        setLoading(false);
      }
    };
    fetchChangelog();
  }, []);

  const formatDate = formatDateOnly;

  const getTypeClass = (type) => {
    switch (type) {
      case 'feature': return 'chg-feature';
      case 'improvement': return 'chg-improvement';
      case 'bugfix': return 'chg-bugfix';
      default: return 'chg-default';
    }
  };

  return (
    <div className="changelog-page">
      <header className="changelog-header">
        <h1>📰 Changelog</h1>
        <p>Novidades e atualizações do sistema</p>
        <button className="back-btn" onClick={() => navigate('/overview')}>← Voltar</button>
        {/* Publicar changelog é uso interno — só ADM, ninguém mais */}
        {user && (
          (hasPermission('changelog.update', ['ADM', 'ADMIN']) ||
           hasPermission('changelog.create', ['ADM', 'ADMIN'])) ? (
          <button className="btn btn-primary btn-sm" onClick={() => navigate('/changelog/admin')}>⚙️ Gerenciar</button>
        ) : null)}
      </header>

      <main className="changelog-content">
        {loading && <div className="loading">Carregando...</div>}
        {error && <div className="error">{error}</div>}
        {!loading && !error && (
          <div className="changelog-list">
            {items.map((item) => (
              <div key={item.id} className={`changelog-item ${getTypeClass(item.type)}`}>
                <div className="item-icon">{item.icon || '📝'}</div>
                <div className="item-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <span className="item-date">{formatDate(item.date)}</span>
                </div>
              </div>
            ))}
            {items.length === 0 && (
              <div className="empty">Nenhuma atualização disponível no momento.</div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default Changelog;